export default "__VITE_ASSET__COwdJqJP__"